import { EnhancedStore } from "@reduxjs/toolkit";
import { AnyAction } from "redux";
import { Persistor } from "redux-persist";

export class LocalStorage {
  public constructor(store: EnhancedStore<any, AnyAction>, persistor: Persistor) {
    this.store = store;
    this.persistor = persistor;
  }

  private readonly store: EnhancedStore<any, AnyAction>;
  private readonly persistor: Persistor;

  public getStore() {
    return this.store;
  }

  public getPersistor() {
    return this.persistor;
  }
}
